import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/features", label: "阅读功能" },
  { to: "/ranking", label: "漫画排行" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

const categoryLinks = [
  "热血少年",
  "玄幻仙侠",
  "都市生活",
  "悬疑推理",
  "恋爱言情",
  "治愈暖心",
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-12 sm:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-open-fill text-xl"></i>
            </span>
            <span className="font-heading text-xl text-background-50">新新漫画网</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-200/90">
            海量漫画随心看，收藏、订阅、离线、历史记录与个性化推荐全支持。追更更顺手，看书更自在。
          </p>
        </div>

        <div>
          <h3 className="text-sm font-bold text-background-50">快速导航</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {quickLinks.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="inline-flex items-center gap-1.5 text-background-200/90 transition hover:text-primary-300"
                >
                  <i className="ri-arrow-right-s-line"></i>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-bold text-background-50">热门分类</h3>
          <ul className="mt-4 flex flex-wrap gap-2">
            {categoryLinks.map((c) => (
              <li key={c}>
                <Link
                  to={`/ranking?cat=${encodeURIComponent(c)}`}
                  className="inline-block rounded-full border border-background-200/30 px-3 py-1 text-xs text-background-200/90 transition hover:border-primary-400 hover:text-primary-300"
                >
                  {c}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-bold text-background-50">联系我们</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-background-200/90">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-300"></i>
              service@xinxinmanhua.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-question-answer-line text-primary-300"></i>
              在线客服 · 工作日 9:00-21:00
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-primary-300"></i>
              更新不停歇 · 天天有新番
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200/15">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-300 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 新新漫画网 · 仅供学习交流，请支持正版漫画</p>
          <p className="flex items-center gap-1">
            <i className="ri-heart-line text-primary-400"></i> 用心做阅读，陪你追更每一天
          </p>
        </div>
      </div>
    </footer>
  );
}